export default "__VITE_ASSET__Dyoc$U3s__"